module.exports = __webpack_public_path__ + "static/media/family-house.e8128467.svg";